import { Country } from "./country";
import { Supplier } from "./supplier";

export class SupplierCountryId {
  supplierId?: number;
  countryId?: number;
}
export class SupplierCountry {
  id: SupplierCountryId = new SupplierCountryId();
  supplier?: Supplier;
  country?: Country = new Country();
}
